module.exports = "https://web-assets.ifttt.com/packs/media/solutions_by_industry/chevron-1a2df35b.svg";